import { Platform } from 'react-native';
import { shouldSkipOfflineCache } from './environments';

export const shouldUseOfflineReviewWorkflow = (): boolean =>
  Platform.OS !== 'web' && !shouldSkipOfflineCache;
